import { Card, Container } from "react-bootstrap";

import PageHeader from "../../components/PageHeader";

const AboutUs = () => {
  return (
    <>
      <Container className="w-800 mt-5 pb-5">
        <PageHeader title="About Us" />
        <Card>
          <Card.Body>
            <section className="mb-5">
              <h3 className="text-primary">Our Mission</h3>
              <p className="leading-para">
                At MyTaxClub, our unwavering mission is to seamlessly integrate cutting-edge
                technology into the preparation of ITRs. We are committed to simplifying the
                processes involved, making tax filing a breeze for our clients. We also aim to
                revolutionize Tax filing process with this technology and AI to reduce human
                participation while increasing efficiency.
              </p>
            </section>
            <section className="mb-5">
              <h3 className="text-primary">Our Values</h3>
              <p className="leading-para">
                We are devoted to empowering Indian taxpayers to file their Income Tax Returns
                effortlessly. At MyTaxClub, we achieve it by upholding numerous core values that
                also define our approach to tax compliance and customer satisfaction.
              </p>
            </section>
            <section>
              <h3 className="text-primary">Our Journey</h3>
              <p className="leading-para">
                We saw a clear need in the market as a group of youthful, progressive chartered
                accountants with five to six years of expertise in the tax filing field. Tax
                professionals were still dependent on manual, labor-intensive processes for
                submitting Income Tax Returns (ITRs), even though they lived in a technologically
                advanced age. The process was slowed down and error-prone due to the manual data
                entry on the IT site and the dependence on Excel sheets for computations. This
                realization was our catalyst for change. We had been using these traditional methods
                for years and felt it was time for a shift.
              </p>
            </section>
          </Card.Body>
        </Card>
        <p className="leading-para text-end">
          For more info{" "}
          <span
            role="button"
            className="text-primary text-decoration-underline"
            onClick={() => window.open(`https://mytaxclub.in/about-us/`, "_blank")}
          >
            Click Here
          </span>
        </p>
      </Container>
    </>
  );
};

export default AboutUs;
